import {
  GetAliveEcoaAuthenticateCodeSmsRequest,
  GetAliveEcoaAuthenticateCodeSmsResponse,
  VerifyEcoaAuthenticateCodeRequest,
  VerifyEcoaAuthenticateCodeResponse,
} from "./EcoaAuthenticateCode.dto";
import { EcoaAuthenticateCodeUrl } from "./EcoaAuthenticateCode.url";
import { restReq } from "../../common/cyan.types";
import { FxApiRequestData, FxRequestData } from "../../common/flax.types";

export class EcoaAuthenticateCodeFlax {
  public static verifyEcoaAuthenticateCode(
    data: FxRequestData<VerifyEcoaAuthenticateCodeRequest>
  ): FxApiRequestData<VerifyEcoaAuthenticateCodeResponse> {
    return {
      ...restReq(process.env.REACT_APP_CDMS_BE_URL, EcoaAuthenticateCodeUrl.verifyEcoaAuthenticateCode, data),
      reducer: resp => resp,
      errReducer: resp => resp,
    };
  }

  public static getAliveEcoaAuthenticateCodeSms(
    data: FxRequestData<GetAliveEcoaAuthenticateCodeSmsRequest>
  ): FxApiRequestData<GetAliveEcoaAuthenticateCodeSmsResponse> {
    return {
      ...restReq(process.env.REACT_APP_CDMS_BE_URL, EcoaAuthenticateCodeUrl.getAliveAuthenticateCodeSms, data),
      reducer: resp => resp,
      errReducer: resp => resp,
    };
  }
}
